export const projectCategories = [
  { id: 'all', name: 'Todos os Projetos' },
  { id: 'saude', name: 'Saúde' },
  { id: 'educacao', name: 'Educação' },
  { id: 'institucional', name: 'Institucional' },
  { id: 'comercial', name: 'Comercial' },
];
